import { gql } from "@apollo/client";

export const MUTATION_CHANGE_ALERT_TRACKING_STATUS = gql`
  mutation MyMutation($alertIds: [uuid!], $newStatus: String) {
    update_userAlertTracking(where: {id: {_in: $alertIds}}, _set: {alertStatusId: $newStatus}) {
      returning {
        alertSeverity
        alertStatusId
        alertTypeId
        created_at
        doctorComment
        doctorId
        drugComment
        drugName
        id
        isDrugTaken
        measure
        processId
        sideEffectComment
        sideEffectName
        sideEffectSeverity
        updated_at
        userComment
        userDrugHistoryId
        userId
        userReportDate
        userSideEffectHistoryId
        userToProcessId
        userVitalSignHistoryId
        vitalSignComment
        vitalSignName
      }
    }
  }
`;
  